<!--
NFC > directions > building to screen
@author bmk11u
-->
<template>
  <div>
    <Nav name="Building"/>
    <SearchList name="building" id="buildingId" label="buildingName" data="/map/buildings"
      :href="'goingtoroom?x=' + x + '&y=' + y + '&buildingId={buildingId}&buildingName={buildingName}'" />
      <div id="pusher"></div>
    <Footer active="notifications" v-if="authenticated"/>
  </div>
</template>

<script>
import SearchList from '@/components/SearchList.vue'
import LocationsCommon from '@/mixins/LocationsCommon.js'
import Footer from '@/components/FooterMenu.vue'

export default {
  name: 'GoingToBuilding',
  components: {
    SearchList
  },
  mixins: [
    LocationsCommon,
    Footer
  ],
  data () {
    return {
      authenticated: this.$cookies.get('authenticated'),
      x: this.$route.query.x,
      y: this.$route.query.y
    }
  }
}
</script>
